var _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _polygon, _polygon2, _polygon3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "medal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "transparent_squares",
    "data-name": "transparent squares"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "transparent-square",
    x: 0.55,
    width: 500,
    height: 500,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "medal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ring",
    d: "M301.34,48.86c0-.42-.08-.83-.13-1.25s-.08-.71-.13-1.06l0-.2a50,50,0,0,0-49.5-43h-1a50,50,0,0,0-48.71,44.69c0,.26-.06.53-.08.8l-.06.68c-.1,1.26-.15,2.54-.15,3.82A49.67,49.67,0,0,0,208.8,79.3a0,0,0,0,0,0,0q.19.33.42.66h0c.12.2.24.39.37.58,0,0,0,0,0,0a48.74,48.74,0,0,0,7.49,9h0l.74.68.31.29a49.76,49.76,0,0,0,32.4,12.79h1a49.75,49.75,0,0,0,33.72-13.1l1-1h0l.84-.83A49.17,49.17,0,0,0,293.88,80c.22-.36.44-.72.65-1.08s.43-.73.64-1.1a49.6,49.6,0,0,0,6.38-24.43C301.55,51.86,301.48,50.35,301.34,48.86ZM250.55,28.38a23,23,0,0,1,21.89,16q-4.29-.39-8.64-.62h0l-13.24-.15h-1.4l-4.6,0q-6.83.21-13.55.81c-.81.07-1.61.15-2.41.24A23,23,0,0,1,250.55,28.38Z",
    style: {
      fill: "#fdba2b"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "edges"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.27,271.82c0-.74-.08-1.48-.13-2.22,0-.51-.07-1-.11-1.55-.07-1.09-.16-2.18-.26-3.26,0-.6-.11-1.2-.17-1.79s-.15-1.46-.23-2.19-.16-1.46-.25-2.18-.18-1.45-.28-2.17c-.17-1.27-.35-2.53-.54-3.79-.07-.49-.15-1-.23-1.47-.15-.91-.3-1.82-.46-2.72-.06-.37-.12-.74-.19-1.1-.16-.9-.33-1.79-.51-2.68q-.32-1.62-.66-3.24c-.14-.65-.28-1.31-.43-2s-.35-1.56-.54-2.33-.32-1.34-.49-2-.34-1.4-.53-2.09-.36-1.38-.55-2.07c-.37-1.38-.76-2.76-1.17-4.12-.2-.69-.41-1.37-.62-2-.43-1.41-.88-2.81-1.35-4.19-.21-.63-.42-1.26-.64-1.89s-.43-1.26-.66-1.89c-.28-.79-.56-1.57-.86-2.35-.23-.63-.46-1.25-.7-1.87-.55-1.45-1.13-2.9-1.72-4.33-.34-.82-.68-1.64-1-2.46s-.69-1.6-1-2.4-.78-1.75-1.18-2.62c-.26-.57-.52-1.13-.79-1.69s-.6-1.27-.91-1.9-.63-1.3-1-1.94q-.92-1.86-1.89-3.69c-.32-.62-.65-1.24-1-1.85s-.67-1.24-1-1.85c-.68-1.22-1.37-2.44-2.07-3.64s-1.47-2.49-2.23-3.72c-.34-.56-.68-1.11-1-1.66s-.74-1.18-1.12-1.77l-1.14-1.75c-.38-.59-.77-1.17-1.16-1.74s-.78-1.16-1.18-1.73q-2.36-3.45-4.88-6.78c-.42-.56-.84-1.11-1.27-1.66l-1.28-1.65c-.43-.55-.86-1.09-1.3-1.63s-.87-1.08-1.32-1.62c-.88-1.08-1.77-2.14-2.68-3.19s-1.82-2.1-2.75-3.13l-2-2.16c-.1-.12-.21-.24-.32-.35-.65-.7-1.3-1.39-2-2.08-.48-.51-1-1-1.45-1.5s-1-1-1.46-1.48l-1.48-1.47c-.75-.74-1.51-1.47-2.27-2.19-.37-.36-.75-.72-1.13-1.06s-.68-.65-1-1-.73-.68-1.09-1l-1.1-1-2.22-2q-1.12-1-2.25-1.92c-.6-.51-1.21-1-1.82-1.51q-1.83-1.52-3.69-3c-.83-.65-1.66-1.29-2.5-1.92-.49-.38-1-.75-1.49-1.12l-1.69-1.24-1.69-1.21-1.71-1.2q-3.6-2.49-7.31-4.82l-.56-.35c-1.11-.7-2.23-1.38-3.35-2q-.84-.51-1.68-1l-1.7-1-1.39-.79c-.89-.5-1.79-1-2.69-1.47-.65-.35-1.29-.69-1.94-1s-1.55-.81-2.34-1.21-1.56-.79-2.35-1.17c-.55-.28-1.11-.55-1.67-.81l-.74-.35-.73-.34-2.12-1c-1-.44-1.94-.87-2.92-1.29-2.06-.9-4.14-1.75-6.24-2.57-.54-.22-1.08-.43-1.63-.63l-1.63-.62L318,99l-1.51-.54-1.87-.65c-.62-.22-1.25-.43-1.87-.63q-1.59-.52-3.18-1c-.66-.21-1.31-.41-2-.6l-2.84-.83-1.79-.49-1.56-.42c-1.41-.38-2.84-.73-4.26-1.07l-2.39-.56-1.93-.42-1.56-.33-1.68-.34-2.33-.44-1.94-.36-.4-.06-2.08-.35c-1.14-.18-2.28-.36-3.42-.52l-3.45-.46c-.93-.12-1.87-.23-2.8-.33s-1.77-.19-2.66-.27-1.78-.17-2.67-.24l-2.69-.2c-.89-.07-1.79-.12-2.69-.17s-1.7-.09-2.56-.12-1.49-.06-2.23-.08l-1.33,0q-2.37-.06-4.74-.06h-1c-.38,0-.76,0-1.15,0l-1.75,0-1.74,0c-1.17,0-2.34.08-3.5.13l-2.13.11-1.18.07c-.78,0-1.57.1-2.35.17l-1.6.12-2.26.2-1.42.14-1.75.19c-.7.07-1.4.15-2.09.24-1.4.17-2.78.36-4.16.56l-2.07.31q-1,.15-2.07.33l-1.49.25-.82.15-.92.17-.87.16q-3.07.57-6.1,1.25l-1.29.29c-.93.21-1.87.43-2.8.66l-1.52.38c-1,.25-2,.52-3,.79l-1.36.37c-1,.27-1.95.55-2.92.84l-2.14.65-1.58.49-1.37.44-1.61.53-1.58.54c-1.26.43-2.52.88-3.76,1.34-.83.3-1.66.61-2.48.93l-2.5,1-1.51.61-2.6,1.09c-.92.39-1.84.79-2.75,1.2l-1.84.83-1.83.85c-.61.28-1.22.57-1.82.87s-1.12.53-1.67.81l-2,1c-.6.3-1.19.61-1.78.92l-1.78.94q-.9.47-1.77,1l-1.5.83q-2.33,1.29-4.6,2.66c-.45.26-.89.53-1.33.8q-2.34,1.41-4.63,2.9c-.57.36-1.12.73-1.68,1.1-1,.64-1.95,1.29-2.91,2s-1.92,1.33-2.87,2l-1.61,1.16c-.81.59-1.61,1.19-2.41,1.79-.54.4-1.07.8-1.59,1.21s-1.05.81-1.57,1.22q-1.35,1.05-2.67,2.13c-.39.31-.77.62-1.15.95l-1,.86L125,134c-1,.87-2,1.74-3,2.63L120.52,138c-1,.89-2,1.8-2.93,2.71-.71.67-1.42,1.35-2.12,2L114,144.16c-.24.23-.47.46-.7.7-.94.94-1.87,1.89-2.79,2.86-.46.48-.92,1-1.37,1.45q-1.37,1.46-2.7,2.94l-1.32,1.49-1.31,1.5c-.49.56-1,1.13-1.45,1.7s-1.05,1.24-1.56,1.87-1,1.2-1.46,1.81c-.72.89-1.43,1.78-2.12,2.69s-1.21,1.57-1.81,2.37c-.09.11-.18.23-.26.35-.54.72-1.08,1.45-1.61,2.19q-1.6,2.21-3.13,4.44c-.37.55-.75,1.1-1.12,1.66s-.73,1.11-1.1,1.67c-.73,1.12-1.45,2.24-2.16,3.38s-1.4,2.26-2.09,3.41h0q-1,1.68-2,3.39l-.06.12c-.66,1.15-1.3,2.31-1.93,3.47-.32.59-.64,1.18-1,1.77l-.93,1.79-.51,1-.49,1c-.41.82-.81,1.64-1.21,2.46s-.79,1.64-1.17,2.47c-.19.39-.37.77-.54,1.16s-.33.71-.48,1.06-.31.71-.47,1.06c-.28.6-.54,1.2-.8,1.81-.42,1-.84,2-1.25,3-.21.53-.43,1.05-.64,1.58-.47,1.16-.92,2.32-1.36,3.48-.28.74-.55,1.47-.82,2.21-.21.57-.42,1.15-.62,1.72s-.5,1.41-.74,2.12-.44,1.28-.65,1.93-.42,1.29-.63,1.94-.41,1.3-.61,1.95c-.4,1.31-.79,2.62-1.16,3.93-.19.66-.37,1.32-.55,2s-.36,1.32-.53,2-.35,1.33-.51,2-.33,1.33-.49,2c-.21.86-.4,1.72-.6,2.58-.28,1.27-.56,2.56-.82,3.84-.17.86-.34,1.73-.5,2.59q-.56,2.9-1,5.82l-.15,1c-.15,1-.29,1.93-.42,2.89-.08.59-.16,1.17-.23,1.76-.18,1.39-.34,2.77-.49,4.17q-.12,1.05-.21,2.1c-.07.71-.14,1.42-.19,2.13s-.11,1.23-.15,1.84l0,.42c0,.65-.09,1.29-.13,1.94s-.08,1.33-.11,2-.07,1.31-.1,2l-.09,2.26v.18c0,.07,0,.14,0,.2,0,.94.06,1.89.11,2.83,0,.53.05,1.05.08,1.58.06,1.26.14,2.51.24,3.76.05.68.1,1.36.16,2,0,.47.07.95.12,1.42,0,0,0,.11,0,.17.13,1.46.28,2.92.45,4.37.12,1,.24,2,.37,3,.1.79.21,1.57.32,2.35,0,.05,0,.1,0,.14.09.6.17,1.21.27,1.81.18,1.18.37,2.35.57,3.52.15.88.31,1.76.47,2.63.11.62.23,1.25.36,1.87s.27,1.4.42,2.09.29,1.39.44,2.09c.3,1.34.61,2.68.93,4l.24,1c.32,1.32.66,2.62,1,3.93l.54,2c.39,1.42.81,2.83,1.24,4.24l.45,1.46c.43,1.35.86,2.7,1.32,4,.1.31.21.62.32.93.28.82.57,1.65.86,2.46l.9,2.45c.19.52.39,1,.59,1.56.49,1.27,1,2.54,1.5,3.79.39,1,.79,1.9,1.19,2.84s.93,2.15,1.41,3.22q.28.66.6,1.32l.75,1.62q.74,1.57,1.5,3.12c.48,1,1,2,1.47,3q1,1.89,2,3.75c.41.76.82,1.51,1.24,2.26s.84,1.5,1.27,2.25c.65,1.13,1.31,2.25,2,3.37s1.32,2.17,2,3.24,1.38,2.17,2.09,3.25c.35.54.7,1.07,1.06,1.6s.72,1.07,1.08,1.6l1.26,1.82c.47.67.94,1.33,1.42,2s.83,1.15,1.26,1.72q2.31,3.14,4.74,6.18,1.14,1.43,2.31,2.82c.19.24.38.47.58.7l.59.7c.79.93,1.59,1.85,2.4,2.77l1,1.18.17.19c.81.9,1.62,1.79,2.44,2.67s1.64,1.75,2.48,2.61,1.67,1.71,2.52,2.56,1.48,1.47,2.23,2.19c1,.95,2,1.88,3,2.8l2.42,2.21,1.47,1.3c.49.44,1,.87,1.48,1.29.74.64,1.49,1.28,2.25,1.91l2.1,1.73,1.19,1c1.9,1.51,3.82,3,5.78,4.44q1.43,1.06,2.88,2.1l.12.09,2.81,1.95c1,.68,2,1.35,3,2h0q1.5,1,3,1.95l2.93,1.82c1.08.65,2.16,1.3,3.25,1.93l1.65.95c.76.43,1.52.86,2.29,1.28l1.57.85c.65.36,1.31.71,2,1s1.29.67,1.94,1c2,1,4,2,6,2.91l1,.47,1,.46,2,.87,2,.85,2,.83,2.17.88,2.17.86c.72.28,1.45.56,2.19.83l2.19.8,2.22.78c.74.26,1.47.51,2.22.75l2.14.7.16.05,2.09.65c1,.3,1.94.59,2.91.86s1.94.56,2.91.82l1.08.29,2.29.59q1.35.35,2.7.66l1.88.44,1.22.27,1.11.24q2.49.54,5,1l2.27.41,2.47.41,2.49.38c.83.13,1.66.24,2.49.35l2.5.32c.59.08,1.17.15,1.76.21s1.2.14,1.8.19l1.82.18,1.67.15,2.34.18c1.33.11,2.68.19,4,.26l1,.05,1.93.08h.4l2,.07c.71,0,1.42,0,2.14,0h1c.31,0,.63,0,.94,0h1c1.26,0,2.52,0,3.78,0,1,0,2,0,3-.08l1.63-.06,2.1-.1q3.18-.17,6.34-.44l2.35-.22.73-.07,1.2-.13.2,0c.54-.05,1.08-.11,1.61-.18,1.29-.15,2.57-.31,3.84-.49.77-.1,1.53-.21,2.29-.33l1-.16c.59-.08,1.18-.18,1.76-.27l1.45-.25c.91-.15,1.81-.32,2.72-.49l2.41-.47,2.39-.49,1.67-.36.84-.19c.94-.21,1.88-.43,2.81-.66,1.12-.27,2.24-.55,3.35-.85.9-.23,1.81-.48,2.71-.73,1.16-.32,2.31-.65,3.46-1l1.5-.45,1.5-.47,3.08-1,3-1h0l3-1.1c.93-.34,1.85-.69,2.77-1.05l3.09-1.23,1.56-.65,1.53-.65,2.93-1.28,1.79-.82,1.12-.52c1.69-.79,3.37-1.6,5-2.45l1.53-.78,2.16-1.13c.88-.47,1.76-.94,2.64-1.43,1.86-1,3.7-2.08,5.52-3.16.91-.54,1.82-1.09,2.72-1.65s1.79-1.11,2.68-1.68,1.78-1.14,2.66-1.73q4-2.64,7.79-5.44c.9-.66,1.8-1.33,2.69-2s1.55-1.19,2.32-1.79a3.15,3.15,0,0,0,.3-.24c1.57-1.23,3.11-2.49,4.64-3.77l2.29-1.95.11-.1c.8-.69,1.59-1.39,2.37-2.09s1.55-1.4,2.32-2.12c.46-.42.92-.84,1.37-1.28l1-.9,1.13-1.09,1.13-1.11,1.54-1.53c.51-.52,1-1,1.52-1.55l1.5-1.57,1.49-1.59,1.6-1.74,1.58-1.77c.53-.6,1.05-1.19,1.56-1.79.69-.8,1.37-1.6,2-2.41l2-2.44,1.57-2c.17-.22.35-.44.51-.66.52-.66,1-1.32,1.53-2,.83-1.08,1.63-2.17,2.43-3.26.53-.73,1.06-1.47,1.58-2.21l1.81-2.61c.6-.87,1.18-1.75,1.76-2.63s1.15-1.78,1.72-2.67,1.13-1.79,1.68-2.69,1-1.71,1.55-2.57a1.29,1.29,0,0,0,.09-.16c.51-.87,1-1.74,1.52-2.62s1-1.76,1.48-2.65.92-1.7,1.37-2.55l1.23-2.34,1.1-2.2c.25-.49.49-1,.73-1.48.32-.65.63-1.31.94-2s.75-1.6,1.12-2.41q1.2-2.64,2.33-5.33c.46-1.08.9-2.16,1.33-3.25.26-.65.52-1.3.77-2a2.49,2.49,0,0,0,.11-.29q.51-1.32,1-2.64c.68-1.83,1.32-3.68,1.94-5.53.32-1,.63-1.9.93-2.86s.57-1.83.84-2.74c.44-1.46.87-2.93,1.27-4.41l.34-1.27c.25-.95.5-1.9.74-2.86s.47-1.92.7-2.88.45-1.93.66-2.89.41-1.95.61-2.92.39-1.95.57-2.93c.12-.64.24-1.28.35-1.92l.33-1.93c.16-1,.32-2,.47-3,.1-.66.2-1.32.29-2,.14-1,.27-2,.39-3,.1-.79.19-1.59.28-2.39,0-.16,0-.32,0-.49.11-.93.2-1.86.29-2.79l0-.35q.07-.69.12-1.38.09-.93.15-1.86c.05-.59.09-1.18.12-1.78,0-.35.05-.7.07-1.05q.09-1.35.15-2.7l0-.65c0-.92.07-1.85.1-2.77C446.41,274.78,446.35,273.3,446.27,271.82Zm-144.93-223-1.13-.25c-2-.45-4.1-.87-6.16-1.26q-10.65-2-21.61-3-4.29-.39-8.64-.62h0l-13.24-.15h-1.4l-4.6,0q-6.83.21-13.55.81c-.81.07-1.61.15-2.41.24-1.31.12-2.62.27-3.92.42h0a221.07,221.07,0,0,0-22.9,3.91l-.92.2c-2.06.46-4.11,1-6.14,1.48C96.84,75.8,24.55,164.65,24.55,270.38c0,123,97.87,223.19,220,226.89,2,.06,4,.1,6,.1h1l2.65,0a226.89,226.89,0,0,0,224.35-227C478.55,162.12,402.76,71.55,301.34,48.86Z",
    style: {
      fill: "#fad263"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    id: "centre",
    cx: 251.55,
    cy: 270.38,
    r: 195,
    style: {
      fill: "#fdba2b"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "upper_shadow",
    "data-name": "upper shadow",
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M446.55,270.38c0,2,0,3.94-.09,5.89C443.23,171.4,357.21,87.38,251.55,87.38c-.72,0-1.43,0-2.15,0-104.71,1.13-189.62,84.78-192.76,189q-.09-3-.09-6c0-107,86.14-193.83,192.85-195,.72,0,1.43,0,2.15,0C359.25,75.38,446.55,162.68,446.55,270.38Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "wreath_shadow",
    "data-name": "wreath shadow",
    style: {
      opacity: 0.1
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.86,
    cy: 432.53,
    rx: 30.47,
    ry: 15.39,
    transform: "translate(-198.75 184.78) rotate(-32.57)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.93,
    cy: 385.23,
    rx: 15.39,
    ry: 30.47,
    transform: "translate(-149.58 145.35) rotate(-26.91)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 168.54,
    cy: 415.52,
    rx: 29.65,
    ry: 14.98,
    transform: "translate(-49.44 23.67) rotate(-7.01)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.68,
    cy: 379.29,
    rx: 14.98,
    ry: 29.65,
    transform: "translate(-86.61 58.38) rotate(-14.1)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.62,
    cy: 384.43,
    rx: 12.39,
    ry: 24.54,
    transform: "translate(-262.95 489.34) rotate(-86.5)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.81,
    cy: 360.28,
    rx: 24.54,
    ry: 12.39,
    transform: "translate(-219.56 469.16) rotate(-82.27)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.67,
    cy: 353.21,
    rx: 10.29,
    ry: 20.36,
    transform: "translate(-261.35 400.77) rotate(-81.07)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.86,
    cy: 336.1,
    rx: 20.36,
    ry: 10.29,
    transform: "translate(-228.46 344.01) rotate(-69.69)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.13,
    cy: 321.83,
    rx: 9.12,
    ry: 18.05,
    transform: "translate(-243.98 330.11) rotate(-75.78)"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.32,
    cy: 310.75,
    rx: 18.05,
    ry: 9.12,
    transform: "translate(-203.21 230.92) rotate(-54.97)"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.48,
    cy: 292.87,
    rx: 8.45,
    ry: 16.74,
    transform: "translate(-217 239.11) rotate(-64.09)"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.66,
    cy: 287.84,
    rx: 16.74,
    ry: 8.45,
    transform: "translate(-178.61 180.97) rotate(-48.7)"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.41,
    cy: 263.49,
    rx: 7.9,
    ry: 15.64,
    transform: "translate(-167.18 145.51) rotate(-47.33)"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.86,
    cy: 265.05,
    rx: 13.57,
    ry: 6.86,
    transform: "translate(-148.56 135.71) rotate(-41.28)"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.52,
    cy: 237.36,
    rx: 7.37,
    ry: 14.6,
    transform: "translate(-101.46 69.18) rotate(-28.09)"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.65,
    cy: 240.38,
    rx: 14.6,
    ry: 7.37,
    transform: "translate(-133.62 134.73) rotate(-42.23)"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.07,
    cy: 212.29,
    rx: 6.4,
    ry: 12.66,
    transform: "translate(-46.03 27.37) rotate(-13.22)"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.17,
    cy: 219.34,
    rx: 12.66,
    ry: 6.4,
    transform: "translate(-94.3 84.25) rotate(-29.8)"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.09,
    cy: 198.12,
    rx: 11.39,
    ry: 5.75,
    transform: "translate(-114.64 223.38) rotate(-67.11)"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 285.12,
    cy: 433.56,
    rx: 15.39,
    ry: 30.47,
    transform: "translate(-233.74 440.41) rotate(-57.43)"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.04,
    cy: 386.26,
    rx: 30.47,
    ry: 15.39,
    transform: "translate(-194.98 454.89) rotate(-63.09)"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 333.43,
    cy: 416.54,
    rx: 14.98,
    ry: 29.65,
    transform: "translate(-120.68 696.66) rotate(-82.99)"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 309.29,
    cy: 380.32,
    rx: 29.65,
    ry: 14.98,
    transform: "translate(-134.92 587.63) rotate(-75.9)"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 373.36,
    cy: 385.46,
    rx: 24.54,
    ry: 12.39,
    transform: "translate(-22.83 23.51) rotate(-3.5)"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 343.17,
    cy: 361.3,
    rx: 12.39,
    ry: 24.54,
    transform: "translate(-45.5 49.47) rotate(-7.73)"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 398.3,
    cy: 354.23,
    rx: 20.36,
    ry: 10.29,
    transform: "translate(-50.18 66.15) rotate(-8.93)"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.12,
    cy: 337.12,
    rx: 10.29,
    ry: 20.36,
    transform: "translate(-94.08 149.11) rotate(-20.31)"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 411.84,
    cy: 322.85,
    rx: 18.05,
    ry: 9.12,
    transform: "translate(-66.71 111.1) rotate(-14.22)"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 381.65,
    cy: 311.78,
    rx: 9.12,
    ry: 18.05,
    transform: "translate(-109.83 275.53) rotate(-35.03)"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 419.5,
    cy: 293.9,
    rx: 16.74,
    ry: 8.45,
    transform: "translate(-86.25 212.8) rotate(-25.91)"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 391.32,
    cy: 288.87,
    rx: 8.45,
    ry: 16.74,
    transform: "translate(-93.31 330.16) rotate(-41.3)"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 419.56,
    cy: 264.51,
    rx: 15.64,
    ry: 7.9,
    transform: "translate(-68.21 354.37) rotate(-42.67)"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 396.11,
    cy: 266.08,
    rx: 6.86,
    ry: 13.57,
    transform: "translate(-65.18 388.22) rotate(-48.72)"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 414.45,
    cy: 238.39,
    rx: 14.6,
    ry: 7.37,
    transform: "translate(8.98 491.75) rotate(-61.91)"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 394.32,
    cy: 241.41,
    rx: 7.37,
    ry: 14.6,
    transform: "translate(-49.45 371.15) rotate(-47.77)"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 406.91,
    cy: 213.32,
    rx: 12.66,
    ry: 6.4,
    transform: "translate(106.18 560.66) rotate(-76.78)"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 390.8,
    cy: 220.37,
    rx: 6.4,
    ry: 12.66,
    transform: "translate(5.37 449.99) rotate(-60.2)"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 390.88,
    cy: 199.15,
    rx: 5.75,
    ry: 11.39,
    transform: "translate(-46.68 167.75) rotate(-22.89)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "wreath"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.86,
    cy: 428.53,
    rx: 30.47,
    ry: 15.39,
    transform: "translate(-196.6 184.15) rotate(-32.57)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.93,
    cy: 381.23,
    rx: 15.39,
    ry: 30.47,
    transform: "translate(-147.77 144.92) rotate(-26.91)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 168.54,
    cy: 411.52,
    rx: 29.65,
    ry: 14.98,
    transform: "translate(-48.95 23.64) rotate(-7.01)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.68,
    cy: 375.29,
    rx: 14.98,
    ry: 29.65,
    transform: "translate(-85.63 58.26) rotate(-14.1)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.62,
    cy: 380.43,
    rx: 12.39,
    ry: 24.54,
    transform: "translate(-258.96 485.59) rotate(-86.5)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.67,
    cy: 349.21,
    rx: 10.29,
    ry: 20.36,
    transform: "translate(-257.4 397.39) rotate(-81.07)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.81,
    cy: 356.28,
    rx: 24.54,
    ry: 12.39,
    transform: "translate(-215.6 465.69) rotate(-82.27)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.86,
    cy: 332.1,
    rx: 20.36,
    ry: 10.29,
    transform: "translate(-224.71 341.4) rotate(-69.69)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.13,
    cy: 317.83,
    rx: 9.12,
    ry: 18.05,
    transform: "translate(-240.1 327.09) rotate(-75.78)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.32,
    cy: 306.75,
    rx: 18.05,
    ry: 9.12,
    transform: "translate(-199.93 229.21) rotate(-54.97)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.48,
    cy: 288.87,
    rx: 8.45,
    ry: 16.74,
    transform: "translate(-213.4 236.86) rotate(-64.09)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.66,
    cy: 283.84,
    rx: 16.74,
    ry: 8.45,
    transform: "translate(-175.61 179.61) rotate(-48.7)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.86,
    cy: 261.05,
    rx: 13.57,
    ry: 6.86,
    transform: "translate(-145.92 134.71) rotate(-41.28)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.41,
    cy: 259.49,
    rx: 7.9,
    ry: 15.64,
    transform: "translate(-164.24 144.22) rotate(-47.33)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.52,
    cy: 233.36,
    rx: 7.37,
    ry: 14.6,
    transform: "translate(-99.58 68.71) rotate(-28.09)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.65,
    cy: 236.38,
    rx: 14.6,
    ry: 7.37,
    transform: "translate(-130.93 133.7) rotate(-42.23)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.07,
    cy: 208.29,
    rx: 6.4,
    ry: 12.66,
    transform: "translate(-45.11 27.26) rotate(-13.22)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.17,
    cy: 215.34,
    rx: 12.66,
    ry: 6.4,
    transform: "translate(-92.31 83.72) rotate(-29.8)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.09,
    cy: 194.12,
    rx: 11.39,
    ry: 5.75,
    transform: "translate(-110.95 220.94) rotate(-67.11)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 285.12,
    cy: 429.56,
    rx: 15.39,
    ry: 30.47,
    transform: "translate(-230.37 438.57) rotate(-57.43)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.04,
    cy: 382.26,
    rx: 30.47,
    ry: 15.39,
    transform: "translate(-191.41 452.7) rotate(-63.09)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 333.43,
    cy: 412.54,
    rx: 14.98,
    ry: 29.65,
    transform: "translate(-116.71 693.15) rotate(-82.99)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 309.29,
    cy: 376.32,
    rx: 29.65,
    ry: 14.98,
    transform: "translate(-131.05 584.6) rotate(-75.9)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 373.36,
    cy: 381.46,
    rx: 24.54,
    ry: 12.39,
    transform: "translate(-22.59 23.5) rotate(-3.5)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 343.17,
    cy: 357.3,
    rx: 12.39,
    ry: 24.54,
    transform: "translate(-44.96 49.43) rotate(-7.73)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 398.3,
    cy: 350.23,
    rx: 20.36,
    ry: 10.29,
    transform: "translate(-49.56 66.1) rotate(-8.93)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.12,
    cy: 333.12,
    rx: 10.29,
    ry: 20.36,
    transform: "translate(-92.69 148.87) rotate(-20.31)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 411.84,
    cy: 318.85,
    rx: 18.05,
    ry: 9.12,
    transform: "translate(-65.72 110.98) rotate(-14.22)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 381.65,
    cy: 307.78,
    rx: 9.12,
    ry: 18.05,
    transform: "matrix(0.82, -0.57, 0.57, 0.82, -107.53, 274.81)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 419.5,
    cy: 289.9,
    rx: 16.74,
    ry: 8.45,
    transform: "translate(-84.5 212.4) rotate(-25.91)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 391.32,
    cy: 284.87,
    rx: 8.45,
    ry: 16.74,
    transform: "translate(-90.67 329.17) rotate(-41.3)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 419.56,
    cy: 260.51,
    rx: 15.64,
    ry: 7.9,
    transform: "translate(-65.5 353.31) rotate(-42.67)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 396.11,
    cy: 262.08,
    rx: 6.86,
    ry: 13.57,
    transform: "translate(-62.17 386.86) rotate(-48.72)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 414.45,
    cy: 234.39,
    rx: 14.6,
    ry: 7.37,
    transform: "translate(12.51 489.64) rotate(-61.91)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 394.32,
    cy: 237.41,
    rx: 7.37,
    ry: 14.6,
    transform: "translate(-46.49 369.84) rotate(-47.77)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 406.91,
    cy: 209.32,
    rx: 12.66,
    ry: 6.4,
    transform: "translate(110.08 557.57) rotate(-76.78)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 390.8,
    cy: 216.37,
    rx: 6.4,
    ry: 12.66,
    transform: "translate(8.84 447.98) rotate(-60.2)",
    style: {
      fill: "#fad263"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 390.88,
    cy: 195.15,
    rx: 5.75,
    ry: 11.39,
    transform: "translate(-45.13 167.44) rotate(-22.89)",
    style: {
      fill: "#fad263"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "small_stars",
    "data-name": "small stars"
  }, /*#__PURE__*/React.createElement("g", {
    id: "star_shadow",
    "data-name": "star shadow",
    style: {
      opacity: 0.1
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "225.24 311.36 193.41 294.7 161.65 311.47 161.56 308.55 167.07 276.1 141.89 251.03 141.84 247.92 177.43 245.8 193.27 213.56 209.22 245.74 244.73 247.73 244.78 250.84 219.1 275.96 225.19 308.25 225.24 311.36"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "225.19 308.25 193.36 291.59 161.59 308.36 167.6 272.95 141.84 247.92 177.38 242.69 193.22 210.45 209.17 242.63 244.73 247.73 219.05 272.85 225.19 308.25",
    style: {
      fill: "#fad263"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "star_shadow-2",
    "data-name": "star shadow",
    style: {
      opacity: 0.1
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "342.74 310.7 310.92 294.04 279.15 310.81 279.07 307.89 284.57 275.44 259.39 250.37 259.34 247.26 294.93 245.14 310.77 212.9 326.73 245.09 362.23 247.08 362.28 250.19 336.61 275.31 342.69 307.59 342.74 310.7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "star-2",
    "data-name": "star"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "342.69 307.59 310.86 290.93 279.1 307.7 285.11 272.29 259.34 247.26 294.88 242.03 310.72 209.79 326.67 241.97 362.23 247.08 336.55 272.2 342.69 307.59",
    style: {
      fill: "#fad263"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "middle_star",
    "data-name": "middle star"
  }, /*#__PURE__*/React.createElement("g", {
    id: "star_shadow-3",
    "data-name": "star shadow",
    style: {
      opacity: 0.1
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "290.22 238.45 252.15 218.53 214.15 238.59 214.04 235.09 220.63 196.28 190.51 166.28 190.45 162.56 233.02 160.03 251.97 121.46 271.06 159.96 313.53 162.34 313.59 166.06 282.88 196.11 290.15 234.73 290.22 238.45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "star-3",
    "data-name": "star"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "290.15 234.73 252.08 214.8 214.08 234.87 221.27 192.5 190.45 162.56 232.96 156.31 251.91 117.74 271 156.24 313.53 162.34 282.81 192.39 290.15 234.73",
    style: {
      fill: "#fad263"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.5b840481f5562fbc0f0fe7dbb9ce7d38.svg";
export { ForwardRef as ReactComponent };